import { render } from "./CourseRequestForm.vue?vue&type=template&id=8c4e65ac"
import script from "./CourseRequestForm.vue?vue&type=script&lang=js"
export * from "./CourseRequestForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\employment\\candidate.dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__